export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7766.16c703c3.jpg";